module.exports = __webpack_public_path__ + "images/emoji/zap.40634c9f0374cbf575fd.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/zap.png
// module id = fOfp
// module chunks = 2